import { useTranslator } from '@Localization';
import classNames from 'classnames';
import { ReactElement } from 'react';
import { GTable, IGColumnProps } from '../../../../../__legacy__/components/table/GTable';
import { ITrainingMatrix, ITrainingMatrixDataField } from '../../../jobMetrics.model';
import { IValidJobType, JOB_STATUS } from '../../../jobs.model';
import { getJobTranslationPrefix } from '../../../utils';

interface IProps {
  matrix: ITrainingMatrix;
  status?: JOB_STATUS;
  jobType: IValidJobType;
}

export const ConfusionMatrix = ({ matrix, jobType, status }: IProps): ReactElement => {
  const { t } = useTranslator();
  const translationPrefix = getJobTranslationPrefix(jobType);

  const gMatrix: IGColumnProps<ITrainingMatrixDataField>[] = [
    {
      headerName: '',
      renderer: (x: ITrainingMatrixDataField) => <div className='confusion-matrix-name-cell'>{x.name}</div>,
    },
    ...matrix.fields.map((field, index) => ({
      headerName: field.label,
      renderer: (x: ITrainingMatrixDataField): ReactElement => {
        const dataFieldIndex = matrix.data.findIndex((field) => field.id === x.id);
        const isValidCell = dataFieldIndex === index;
        return <span className={classNames({ 'valid-cell': isValidCell, 'invalid-cell': !isValidCell })}>{x[field.value]}</span>;
      },
    })),
  ];

  if (matrix.data.length === 0) {
    return (
      <>
        <h5>{t('confusion_matrix.title')}</h5>
        <div className='no-data'>
          {status && [JOB_STATUS.FINISHED, JOB_STATUS.IMPORTED].includes(status)
            ? t(`${translationPrefix}.no_data_for_current_process`)
            : t(`${translationPrefix}.data_unavailable_during_process`)}
        </div>
      </>
    );
  }

  return (
    <>
      <h5>{t('confusion_matrix.title')}</h5>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <span style={{ paddingLeft: 60, fontWeight: 700, fontSize: 20 }}>{t('confusion_matrix.predicted')}</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <span style={{ transform: 'rotate(-90deg)', fontWeight: 700, fontSize: 20 }}>{t('confusion_matrix.actual')}</span>
        <GTable
          className='confusion-matrix'
          columns={gMatrix}
          items={matrix.data}
          isLoading={false}
          noItemsPlaceholder={''}
        />
      </div>
    </>
  );
};
